<template>
  <div style="width:100%;" class="px-10">
    <p class="text-h4 py-5">Billing Information</p>
    <v-text-field v-model="formData.ap_contact" name="billing_name" :rules="[rules.required]"
      label="Billing Contact Name" outlined></v-text-field>
    <v-text-field v-model="formData.ap_name" name="billing_company" :rules="[rules.required]"
      label="Billing Company Name" outlined></v-text-field>
    <div class="d-flex">
      <v-text-field v-model="formData.ap_phone" name="billing_phone" :rules="[rules.required]" class="pr-2"
        label="Billing Phone" outlined></v-text-field>
      <v-text-field v-model="formData.ap_email" name="billing_email" :rules="[rules.email]" class="pl-2"
        label="Billing Email" outlined></v-text-field>
    </div>
    <div class="d-flex">
      <v-text-field v-model="formData.ap_address" class="pr-2" name="billing_address" :rules="[rules.required]"
        label="Billing Address" outlined></v-text-field>
      <v-text-field v-model="formData.purchase_order" name="purchase_order" class="pl-2" label="Purchase Order Number"
        :rules="[rules.required]" v-if="formData.purchase_order_required" outlined></v-text-field>
      <v-text-field name="purchase_order" class="pl-2" label="Purchase Order Number" v-model="formData.purchase_order" v-else outlined></v-text-field>
    </div>
    <div class="d-flex flex-column" v-if="!isExistingCustomer">
      <div class="d-flex">
        <v-text-field label="Customer PIN #" class="pr-5" name="master_pin" v-model="formData.master_pin"
          :disabled="generatePin" outlined></v-text-field>
        <v-checkbox v-model="generatePin" label="Randomly Generate a PIN For Me"></v-checkbox>
      </div>
      <p class="grey--text">
        A Customer PIN # is a 4-digit number to ensure the security of your account.
        Please ensure you store this number in a safe place as it will be required
        for any future account changes or inquiries.
      </p>
    </div>
    <v-checkbox v-model="formData.purchase_order_required" label="Purchase Order Required"></v-checkbox>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
// import _ from 'lodash';

export default {
  name: 'ApBillng',
  components: {},
  data: () => ({
    step: 1,
    generatePin: true,
    formData: {
      ap_contact: '',
      ap_name: '',
      ap_phone: '',
      ap_email: '',
      ap_address: '',
      purchase_order: '',
      purchase_order_required: false,
      master_pin: '',
    },
    rules: {
      required: (value) => !!value || 'Required.',
      email: (value) => {
        const pattern = /^[A-Za-z0-9._%+-]+@(?:[A-Za-z0-9-]+\.)+[A-Za-z]{2,}$/;
        return pattern.test(value) || 'Invalid e-mail.';
      },
    },
  }),
  mounted() {
    // const vm = this;
    // const generalData = _.cloneDeep(this.getFormData.general);
    if (!this.getFormData.general.master_pin || this.getFormData.general.master_pin === "") {
      this.formData.master_pin = Math.floor(1000 + Math.random() * 9000);
    } else {
      this.formData.master_pin = this.getFormData.general.master_pin;
      this.generatePin = false;
    }
    // console.log(this.getFormData);
    // console.log(this.getQuoteFacts);

    // Removes step 1 if AP Contact exists
    /* if (this.getFormData.general.ap_contact) {
      this.$set(this.formData, 'has_ap_contact', "y");
      this.step = 2;
    } */

    const phone = this.getQuoteFacts.billing_npa
      + this.getQuoteFacts.billing_nxx
      + this.getQuoteFacts.billing_end;

    this.formData.ap_contact = this.getFormData.general.ap_contact || '';
    this.formData.ap_name = this.getFormData.general.ap_name || this.getQuoteFacts.billing_name;
    this.formData.ap_phone = this.getFormData.general.ap_phone || phone;
    this.formData.ap_email = this.getFormData.general.ap_email || this.getQuoteFacts.billing_email;
    this.formData.ap_address = this.getFormData.general.ap_address
      || this.getQuoteFacts.billing_address;
    this.formData.purchase_order = this.getFormData.general.purchase_order || '';
    this.formData.purchase_order_required = this.getFormData.general.purchase_order_required
      || false;

    /* if (!this.review) {
      this.hijackStepper((goRight) => {
        if (
          (vm.step === 1 && !goRight)
          || (vm.step === vm.maxStep && this.formData.ap_contact && !goRight)
          || (vm.step === vm.maxStep && goRight)
        ) {
          vm.unHijackStepper();
          vm.nextSubTab(goRight);
        }

        vm.step += goRight ? 1 : -1;
      });
    } */
  },
  computed: {
    ...mapGetters([
      'getFormData',
      'getQuoteFacts',
      'isExistingCustomer',
    ]),
    maxStep() {
      if (this.formData.has_ap_contact === 'n') {
        return 1;
      }
      return 2;
    },
  },
  methods: {
    ...mapActions([
      'updateStoreFormData',
      "hijackStepper",
      "unHijackStepper",
      "nextSubTab",
    ]),
    registerFormChange(val) {
      const keys = Object.keys(val);
      keys.forEach((key) => {
        const updatePayload = {
          data: val[key],
          main: 'general',
          sub: key,
        };
        console.log(`sending payload ${JSON.stringify(updatePayload)}`);
        this.updateStoreFormData(updatePayload);
      });
    },
    isExistingCustomer() {
      return this.isExistingCustomer;
    },
  },
  watch: {
    formData: {
      handler(val) {
        this.registerFormChange(val);
      },
      deep: true,
    },
    generatePin(newVal) {
      if (newVal) {
        this.formData.master_pin = Math.floor(1000 + Math.random() * 9000);
      }
    },
  },
};
</script>
